import React, { useEffect, useState, useMemo } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Navbar from "../component/Navbar";
import "./Home.css";
import { useDispatch, useSelector } from "react-redux";
import { jobLoadAction, filterJobs } from "../redux/actions/jobAction";
// import SelectField from "../component/SelectField";
import Footer from "../component/Footer";
import hero from "../images/machanics.jpg";
import airline from "../images/airline.jpg";
import coding from "../images/coding.jpeg";
import doctor from "../images/doctors.jpg";
import { countries } from "../data/countries";
import axios from "../axios/axios";
import JobCard from "../component/JobCard";
import FilterSlider from "../component/FilterSlider";
import { FaSearch } from "react-icons/fa";
import JobCard2 from "../component/JobCard2";
import CircularProgress from "@mui/material/CircularProgress";

const Home = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const { loading, jobs } = useSelector((state) => state.loadJobs);
  const [filter, setFilter] = useState({
    keyword: "",
    location: "lebanon",
    position: "",
  });
  const images = [hero, airline, coding, doctor];

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentImageIndex(
        (currentIndex) => (currentIndex + 1) % images.length
      );
    }, 3000);

    return () => clearInterval(intervalId);
  }, [images, setCurrentImageIndex]);

  const [currentPage, setCurrentPage] = useState(1);

  const jobsPerPage = 8;
  const totalPages = Math.ceil(jobs?.length / jobsPerPage);
  const pageNumbers = [];

  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const handleClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    window.scroll(0, 0);
    dispatch(jobLoadAction());
  }, [dispatch]);

  useEffect(() => {
    AOS.init({
      duration: 2000,
      once: true,
    });
  }, []);
  const [selectedOption, setSelectedOption] = useState('Figma');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleSelectClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsMenuOpen(false);
  };

  // const handleChangeCategory = (e) => {
  //   setCat(e.target.value);
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log(filter);
      dispatch(filterJobs(filter));
      setFilter({ keyword: "", location: "lebanon", position: "" });
    } catch (error) {
      console.log(error);
    }
  };

  const memoizedNavbar = useMemo(() => {
    return <Navbar />;
  }, []);

  return (
    <>
      {memoizedNavbar}
      <section
        className="home-section section-hero overlay"
        style={{
          backgroundImage: `url(${images[currentImageIndex]})`,
          transition: "1s",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center center",
          backgroundAttachment: "fixed",
        }}
        id="home-section"
      >
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-md-12">
              <div className="mb-5 text-center " data-aos="slide-left">
                <h1
                  className="text-white font-weight-bold"
                  style={{ fontFamily: "cursive" }}
                >
                  The Easiest Way To Get Your Dream Job
                </h1>
                <p>
                  There is no shortcut to getting your dream job, but by
                  acquiring relevant skills, networking, <br /> and persistence,
                  you can increase your chances of achieving it.
                </p>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="Filter-section" data-aos="slide-right">
                  <div className="ContainE">
                    <div className="section-search">
                      <input
                        onChange={(e) =>
                          setFilter({ ...filter, keyword: e.target.value })
                        }
                        type="text"
                        placeholder="Keywords..."
                      />
                    </div>
                    {/* <div className="section-location">
                      <select
                        onChange={(e) =>
                          setFilter({ ...filter, location: e.target.value })
                        }
                        value={filter.location}
                      >
                        <option value="lebanon">Lebanon</option>
                        <option value="turkey">Turkey</option>
                        <option value="Australia">Australia</option>
                        <option value="London">London</option>
                      </select
                      
                    </div> */}
                    <div className="section-location">
                      <div className='dropdownz'>
                        <div onClick={handleSelectClick}>
                          <span className="selectedz">
                            {selectedOption}
                          </span>
                        </div>
                        <ul className={`menuz ${isMenuOpen ? 'menu-openz' : ''}`}>
                          <li onClick={() => handleOptionClick('Framer')}>Framer</li>
                          <li onClick={() => handleOptionClick('Sketch')}>Sketch</li>
                          <li onClick={() => handleOptionClick('Invision Studio')}>Invision Studio</li>
                          <li onClick={() => handleOptionClick('Figma')} className='activez'>Figma</li>
                          <li onClick={() => handleOptionClick('Adobe XD')}>Adobe XD</li>

                        </ul>
                      </div>
                    </div>
                    <div className="section-category">
                      
                      <select
                        onChange={(e) =>
                          setFilter({ ...filter, position: e.target.value })
                        }
                      >
                        <option value="mechanic">Mechanic</option>
                        <option value="Nurse">Engineer</option>
                        <option value="software developer">Trainer</option>
                      </select>
                    </div>
                  </div>
                  <div className="section-button">
                    <button type="submit" onClick={handleSubmit}>
                      {loading && <CircularProgress size={20} />}
                      {!loading && (
                        <>
                          <span>FIND JOB</span>
                          <FaSearch />
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <br />
      <br />
      <br />
      <br />


      <section className="site-section"  >
        <div className="container">
          <div className="row mb-1 justify-content-center">
            <div className="col-md-7 text-center">
              <h2
                className="mb-2"
                style={{ textTransform: "uppercase", fontFamily: "cursive" }}
              >

                Available Jobs({jobs?.length})
              </h2>
            </div>
          </div>

          {/* <div className="JobFiltering" data-aos="fade-left">
            <FilterSlider />
          </div> */}
          <div className="JobsContainer mx-auto" id="jobs">
            {jobs
              ?.slice(
                (currentPage - 1) * jobsPerPage,
                currentPage * jobsPerPage
              )
              ?.map((job, i) => (
                <>
                  <JobCard2
                    key={i}
                    id={job._id}
                    company={job.company?.name}
                    position={job.position}
                    location={job.jobLocation}
                    type={job.jobType}
                    companyLogo={job.company?.logo}
                  />
                </>
              ))}
          </div>

          <div className="row pagination-wrap mt-5">
            <div className="col-md-6 text-center text-md-left mb-4 mb-md-0"></div>
            <div className="col-md-6 text-center text-md-right">
              <div className="custom-pagination ml-auto">
                <a
                  href="#"
                  className="prev"
                  onClick={(e) => {
                    e.preventDefault();
                    if (currentPage === 1) return;
                    handleClick(currentPage - 1);
                  }}
                  disabled={currentPage === 1}
                >
                  Prev
                </a>
                <div className="d-inline-block">
                  {pageNumbers.map((pageNumber) => (
                    <a
                      key={pageNumber}
                      href="#"
                      className={pageNumber === currentPage ? "active" : ""}
                      onClick={(e) => {
                        e.preventDefault();
                        handleClick(pageNumber);
                      }}
                    >
                      {pageNumber}
                    </a>
                  ))}
                </div>
                <a
                  href="#"
                  className="next"
                  onClick={(e) => {
                    e.preventDefault();
                    if (currentPage === totalPages) return;
                    handleClick(currentPage + 1);
                  }}
                  disabled={currentPage === totalPages}
                >
                  Next
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Home;
